import { render } from "./RemoveModal.vue?vue&type=template&id=3b250e6f&scoped=true"
import script from "./RemoveModal.vue?vue&type=script&lang=js"
export * from "./RemoveModal.vue?vue&type=script&lang=js"

import "./RemoveModal.vue?vue&type=style&index=0&id=3b250e6f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b250e6f"]])

export default __exports__